import rangeClasses from '../constants/range_classes.json';

export function findDepthByBand(bandNumber) {
    const foundBand = rangeClasses.find((band) => band.band == bandNumber);
    if (foundBand) {
        return foundBand.depth_m;
    } else {
        throw new Error(`Band ${bandNumber} not found in range_classes.json`);
    }
}
